document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-edit-search-toggle').forEach((toggle) => {
    toggle.style.cursor = 'pointer';
  });

  // Dawn normally handles this through details-modal.js. This fallback only runs
  // if that custom element failed to register, so it will not double-bind clicks.
  if (customElements.get('details-modal')) return;

  document.querySelectorAll('details-modal.header__search').forEach((modal) => {
    const details = modal.querySelector('details');
    const toggle = modal.querySelector('summary');
    const close = modal.querySelector('.search-modal__close-button');
    const input = modal.querySelector('input[type="search"]');
    if (!details || !toggle) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const opening = !details.hasAttribute('open');
      if (opening) {
        details.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        requestAnimationFrame(() => input && input.focus());
      } else {
        details.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    });

    close?.addEventListener('click', () => {
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      toggle.focus();
    });
  });
});
